/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const openPositionCreateRequestSchema = z.object({
  description: z.string().nullish(),
  locationId: z.int().nullish(),
  name: z.string().min(0).max(255),
  roleId: z.int(),
  skillIds: z.array(z.int()).nullish(),
});
